export const mockTenantBreakdownData = {
    amenityReservations: [
        {
            type: "Franklin Hall",
            amenityReservations: [
                {
                    tenantName: "Perlogic",
                    value: 15,
                },
                {
                    tenantName: "Medicare",
                    value: 21,
                },
                {
                    tenantName: "Affinance",
                    value: 10,
                },
                {
                    tenantName: "Ruledge",
                    value: 8,
                },
                {
                    tenantName: "TechFever",
                    value: 12,
                },
                {
                    tenantName: "Delta",
                    value: 10,
                },
            ],
        },
        {
            type: "Innovation Hub",
            amenityReservations: [
                {
                    tenantName: "Perlogic",
                    value: 2,
                },
                {
                    tenantName: "Medicare",
                    value: 3,
                },
                {
                    tenantName: "Affinance",
                    value: 9,
                },
                {
                    tenantName: "Ruledge",
                    value: 1,
                },
                {
                    tenantName: "TechFever",
                    value: 18,
                },
                {
                    tenantName: "Delta",
                    value: 9,
                },
            ],
        },
        {
            type: "LaSalle Lounge",
            amenityReservations: [
                {
                    tenantName: "Perlogic",
                    value: 4,
                },
                {
                    tenantName: "Medicare",
                    value: 8,
                },
                {
                    tenantName: "Affinance",
                    value: 12,
                },
                {
                    tenantName: "Ruledge",
                    value: 1,
                },
                {
                    tenantName: "TechFever",
                    value: 0,
                },
                {
                    tenantName: "Delta",
                    value: 9,
                },
            ],
        },
        {
            type: "Madison Room",
            amenityReservations: [
                {
                    tenantName: "Perlogic",
                    value: 18,
                },
                {
                    tenantName: "Medicare",
                    value: 10,
                },
                {
                    tenantName: "Affinance",
                    value: 0,
                },
                {
                    tenantName: "Ruledge",
                    value: 4,
                },
                {
                    tenantName: "TechFever",
                    value: 2,
                },
                {
                    tenantName: "Delta",
                    value: 3,
                },
            ],
        },
        {
            type: "Rooftop",
            amenityReservations: [
                {
                    tenantName: "Perlogic",
                    value: 10,
                },
                {
                    tenantName: "Medicare",
                    value: 2,
                },
                {
                    tenantName: "Affinance",
                    value: 1,
                },
                {
                    tenantName: "Ruledge",
                    value: 2,
                },
                {
                    tenantName: "TechFever",
                    value: 3,
                },
                {
                    tenantName: "Delta",
                    value: 0,
                },
            ],
        },
    ],
};
